import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { StatusBadge } from "@/components/StatusBadge";
import { MemberCard } from "@/components/MemberCard";
import { PaymentOptions } from "@/components/PaymentOptions";
import { Loader } from "@/components/Loader";

export default function Membership() {
  const { user, t, lang, refresh } = useApp();
  const [data, setData] = useState(null);
  const load = () => api.get("/membership").then(({ data }) => setData(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!data) return <Loader />;

  const m = data.member;
  const fmt = (d) => d ? new Date(d).toLocaleDateString(lang === "it" ? "it-IT" : "en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "—";
  const active = m.status === "active";

  return (
    <div className="px-6 pt-8 fade-up">
      <h1 className="font-serif-cu text-2xl text-center mb-3">{t("membership")}</h1>
      <div className="flex justify-center mb-8"><StatusBadge status={m.status} /></div>

      {active ? (
        <>
          <MemberCard member={m} showQr={false} />
          <div className="cu-card p-5 mt-6">
            <div className="space-y-3 text-sm">
              <Row label={t("member_no")} value={m.membership_number || "—"} mono />
              <Row label={t("annual_membership")} value="€120 / year" />
              <Row label={t("member_since")} value={fmt(m.join_date)} />
              <Row label={t("valid_until")} value={fmt(m.renewal_date)} />
            </div>
          </div>
        </>
      ) : (
        <PaymentOptions member={m} payment={data.payment} onNotified={() => { load(); refresh(); }} />
      )}
    </div>
  );
}

function Row({ label, value, mono }) {
  return (
    <div className="flex justify-between gap-4 border-b border-[color:var(--cu-border)] last:border-0 pb-2.5 last:pb-0">
      <span className="eyebrow">{label}</span>
      <span className={`text-right text-[color:var(--cu-text)] ${mono ? "font-mono-cu gold-text" : ""}`}>{value}</span>
    </div>
  );
}
